import logoMenuitek from '../../assets/MenuitekLogo.png'

function Banner() {
    return (
        <div className='flex flex-row min-h-[10vh] max-h-[14vh] items-center xl:px-32 px-4 xl:px-10'>
            <img src={logoMenuitek} alt='Logo Menuitek' className=' m-4 w-[20%] max-w-[22vh] h-auto object-contain pt-4 sm:pt-8 lg:pt-10'></img>
            <h1 className='text-[clamp(0.7rem,1.7vw,2.2rem)] flex-1 text-center break-words text-brun-main font-semibold'>Fenêtres, portes, volets, pergolas et store banne</h1>
        </div>
    )
}

export default Banner